import { errorCodes, getUserFriendlyErrorMessage } from '../../../utils/errormessages'
import type { NewServiceVisitType, SetToastError, VisitTypeErrorState } from '../types'
import { checkErrors } from './checkErrors'
import { checkInvalidCombination } from './checkIsVisibilityTypeAllOrNew'
import { checkNamesDublicates } from './checkNamesDublicates'
import { updateServiceTypes } from './updateServiceTypes'

type CheckServiceTypesTablesArgs = {
  serviceTypes: NewServiceVisitType[]
  setError: SetToastError
  setServiceTypes: (types: NewServiceVisitType[]) => void
}

export const checkServiceTypesTables = ({
  serviceTypes,
  setError,
  setServiceTypes,
}: CheckServiceTypesTablesArgs): NewServiceVisitType[] => {
  let localErrors: VisitTypeErrorState[] = []
  let errorOccurred = 0

  const visibilityTypes = serviceTypes.map((serviceType) => serviceType.VisibilityType)

  const hasInvalidCombination = checkInvalidCombination(visibilityTypes)

  const isSomeVisibilityTypeAllOrNew =
    visibilityTypes.includes('all') || visibilityTypes.includes('new') || visibilityTypes.includes('none')

  serviceTypes.forEach((serviceType) => {
    const newErrorsObj = checkErrors(serviceType, setError)
    localErrors.push(newErrorsObj)
  })

  if (!isSomeVisibilityTypeAllOrNew) {
    errorOccurred += 1
    setError(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS))
  }

  if (hasInvalidCombination) {
    errorOccurred += 1
    setError(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS))
  }

  if (serviceTypes.length > 1) {
    const { newLocalErrors, errorsCount } = checkNamesDublicates({
      serviceTypesList: serviceTypes,
      errorsConfig: localErrors,
      setToastError: setError,
    })

    localErrors = newLocalErrors
    errorOccurred += errorsCount
  }

  localErrors.forEach((errorConfig) => {
    if (Object.values(errorConfig.errors).some((errorItem) => Boolean(errorItem))) {
      errorOccurred += 1
    }
  })

  if (errorOccurred) {
    localStorage.setItem('viewServiceError', JSON.stringify(true))
  } else {
    localStorage.removeItem('viewServiceError')
  }

  const updatedServiceTypes = updateServiceTypes({
    serviceTypes,
    localErrors,
    isSomeVisibilityTypeAllOrNew,
    hasInvalidCombination,
  })
  setServiceTypes(updatedServiceTypes)
  return updatedServiceTypes
}
